import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const API = {
    URL_IDENTIFY: '/rest/v2/{site}/paths/identify',
    URL_CATEGORY: '/rest/v2/{site}/categories',
};

if (checkShouldUseMocks()) {
    API.URL_IDENTIFY = '/api/eshop/identify';
    API.URL_CATEGORY = '/api/eshop/category';
}

export const OLD_TO_NEW_FIELD_MAPPING = {
    brands: 'brand',
    eshop_brandtabletsphones: 'brand',
    eshop_brandcomputers: 'brand',
    eshop_brandgaming: 'brand',
    eshop_brandtv: 'brand',
    eshop_brandsmarthome: 'brand',
    eshop_brandwearables: 'brand',
    eshop_brandaccessories: 'brand',
    eshop_pricerange: 'price',
    eshop_internalmemory: 'storage',
    eshop_rammemory: 'ram',
    eshop_screensize: 'screenSize',
    eshop_brand: 'brand',
    eshop_brand_30000: 'brand',
    eshop_5g: 'is5gSupported',
    eshop_5g_fix: 'is5gSupported',
    eshop_camera_battery_builtin: 'integratedBattery',
    eshop_camera_data_transfer: 'videoTransmission',
    eshop_camera_lighting_led: 'ledLighting',
    eshop_camera_memory: 'memory',
    eshop_camera_motion_detection: 'motionSensorAlarm',
    eshop_camera_resolution: 'cameraResolution',
    eshop_camera_type: 'useCaseType',
    eshop_case_type: 'waterResistance',
    eshop_computer_type: 'useCaseType',
    eshop_connectivitytype: 'connectivityType',
    eshop_delay_time: 'delayTime',
    eshop_driving_range: 'drivingRange',
    eshop_internetconnectivity: 'internetConnectivity',
    eshop_main_warranty: 'warranty',
    eshop_material: 'fabric',
    eshop_modemcharacteristic: 'modemCharacteristic',
    eshop_noisecancellation: 'noiseCancellation',
    eshop_os: 'operatingSystem',
    eshop_os_equipment: 'operatingSystem',
    eshop_phones_warranty: 'warranty',
    eshop_printer_type: 'useCaseType',
    eshop_screentype: 'screenType',
    eshop_screen_type: 'screenType',
    eshop_simcard: 'simTypes',
    eshop_speakers_builtin: 'builtInSpeakers',
    eshop_telia_play_app: 'teliaApp',
    eshop_type: 'useCaseType',
    eshop_waterresistance: 'waterResistance',
    fix_color: 'color',
    hard_disk: 'hardDisk',
    instockflag: 'stockStatus',
    product_category: 'category',
    ram: 'ram',
    resolution: 'screenResolution',
    screen_size: 'screenSize',
    series: 'series',
    simtypes: 'simTypes',
    smart_tv: 'isSmartTv',
    specialcharacteristics: 'specialCharacteristics',
    offertype: 'specialOffers',
    '30001': 'warranty',
    cpu: 'cpu',
    video_card_model: 'graphicCard',
    eshop_display: 'screenSize',
    eshop_suitability: 'compatibility',
};

export const IGNORED_OLD_FIELDS = [
    'eshop_4G',
    'color',
    'pricevalue_tvs',
    'memory_type',
    'pricevalue_by10_monthly',
    'price_0_40_by10_monthly',
    'price_0_80_by10_monthly',
    'price_0_200_by50',
    'pricevalue_tabletcomputers',
    'pricevalue_computers',
    'promotion',
];
